import { Skeleton } from '@radix-ui/themes'

const DashboardRiskSkelton = () => {
  return (
    <div className="w-full flex flex-col h-screen">
      {/* Row 1 */}
      <div className="grid grid-cols-2 w-full mb-4 gap-4">
        <div className="w-full flex flex-col gap-4">
          <Skeleton className="h-32" />
          <div className="grid grid-cols-2 gap-4">
            <Skeleton className="h-48" />
            <Skeleton className="h-48" />
          </div>
        </div>
        <Skeleton className="h-full" />
      </div>
      <div className="flex w-full space-x-4 h-[50%] mb-4 justify-between">
        <Skeleton className="h-full w-1/2 flex-grow" />
        <Skeleton className="h-full w-1/2 flex-grow" />
      </div>
      <div className="flex w-full space-x-4 h-[50%] mb-4 justify-between">
        <Skeleton className="h-full w-1/2 flex-grow" />
        <Skeleton className="h-full w-1/2 flex-grow" />
      </div>
    </div>
  )
}

export default DashboardRiskSkelton
